module.exports = __webpack_public_path__ + "interactiveApp/KurzByk/media/6 Vysoky rostenec steaky 2.jpg";